export const FILTER_KEYS_MAP = {
  CATEGORY: 'category',
  FREQUENCY: 'frequency',
  REQUIREMENT: 'requirement',
  FEE_LEVEL: 'feeLevel',
  FEE_SOURCE: 'feeSource',
} as const;

export const FILTER_KEYS_VALUES_ARRAY = Object.values(FILTER_KEYS_MAP);

export const FREQUENCY_DATA = {
  ONE_TIME: { displayName: 'One time' },
  RECURRING: { displayName: 'Recurring' },
} as const;

export const FEE_SOURCE_KEYS = {
  FEED: 'FEED',
  MANUALLY: 'MANUALLY',
};

export const FEE_SOURCE_DATA = {
  [FEE_SOURCE_KEYS.FEED]: { displayName: 'Feed' },
  [FEE_SOURCE_KEYS.MANUALLY]: { displayName: 'Added manually' },
} as const;
